import {
  Avatar,
  Box,
  Button,
  Flex,
  Text,
  Image,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  IconButton,
} from "@chakra-ui/react";

import { HamburgerIcon } from "@chakra-ui/icons";
import { Follow } from "@/types/follow";
/**
 * 关注的人，粉丝列表子组件
 * @returns
 */

type Props = {
  handToBlack?: () => void;
  handNotLetLook?: () => void;
  handNotLook?: () => void;
  handleCancelFollow?: () => void;
  handleCreateFollow?: () => void;
  handMoveOutBlack?:() => void;
  follow: Follow;
  FollowType?: "follow" | "fan" | "black";
  hasFollowThisFan?: boolean;
};
const MyFollowing = (props: Props) => {
  const {
    follow,
    FollowType,
    hasFollowThisFan,
    handToBlack,
    handNotLetLook,
    handNotLook,
    handMoveOutBlack,
    handleCancelFollow,
    handleCreateFollow,
  } = props;

  return (
    <Box h={200}>
      <Flex justifyContent={"space-between"}>
        <Flex>
          <Avatar
            boxSize={"90px"}
            name="Kola Tioluwani"
            src={`/api/v4/users/${follow.user_id}/image`}
          />
          <Box ml="30px">
            <Text fontSize={"18px"} color="#333333" mb="16px">
              {follow.user.nickname ?? follow.user.username}
            </Text>
            <Text mb="20px" fontSize={"14px"} color="#555555">
              {follow.user.followers}关注 | {follow.user.fans}粉丝
            </Text>
            <Flex gap="32px">
              {FollowType === "follow" && (
                <Button
                  borderRadius={"40px"}
                  width={"80px"}
                  height={"33px"}
                  color="#27314D"
                  bgColor="#fff"
                  border={"1px solid #8E94A9"}
                  fontSize="12px"
                  _hover={{
                    color: "#27314D",
                    bgColor: "#CBD1DF",
                    border: "1px solid #8E94A9",
                  }}
                  onClick={handleCancelFollow}
                >
                  已关注
                </Button>
              )}
              {FollowType !== "follow" && hasFollowThisFan && (
                <Button
                  borderRadius={"40px"}
                  width={"80px"}
                  height={"33px"}
                  color="#27314D"
                  bgColor="#fff"
                  border={"1px solid #8E94A9"}
                  fontSize="12px"
                  _hover={{
                    color: "#27314D",
                    bgColor: "#CBD1DF",
                    border: "1px solid #8E94A9",
                  }}
                  onClick={handleCancelFollow}
                >
                  互相关注
                </Button>
              )}
              {FollowType === "fan" && !hasFollowThisFan && (
                <Button
                  borderRadius={"40px"}
                  width={"80px"}
                  height={"33px"}
                  color="#FFFFFF"
                  bgColor="#496AE1"
                  border={"none"}
                  fontSize="12px"
                  _hover={{
                    color: "##E6E6E6",
                    bgColor: "#3F5BC1",
                    border: "1px solid #8E94A9",
                  }}
                  onClick={handleCreateFollow}
                >
                  回关
                </Button>
              )}
              {FollowType === "black" && !hasFollowThisFan && (
                <Button
                  borderRadius={"40px"}
                  width={"80px"}
                  height={"33px"}
                  color="#27314D"
                  bgColor="#fff"
                  border={"1px solid #8E94A9"}
                  fontSize="12px"
                  _hover={{
                    color: "#27314D",
                    bgColor: "#CBD1DF",
                    border: "1px solid #8E94A9",
                  }}
                  // onClick={}
                >
                  已关注
                </Button>
              )}
              {FollowType !== "follow" && (
                <Button
                  borderRadius={"40px"}
                  width={"80px"}
                  height={"33px"}
                  color="#27314D"
                  bgColor="#fff"
                  border={"1px solid #8E94A9"}
                  fontSize="12px"
                  _hover={{
                    color: "#27314D",
                    bgColor: "#CBD1DF",
                    border: "1px solid #8E94A9",
                  }}
                >
                  私信
                </Button>
              )}
            </Flex>
          </Box>
        </Flex>
        <Flex gap="15px">
          {follow.contents.map((item, index) => {
            if (index < 4) {
              return <Image src={item.image_url} w={160} h={160} />;
            }
          })}
          {/* <Button
            leftIcon={<HamburgerIcon />}
            size="xs"
            variant="ghost"
          ></Button> */}
          <Menu>
            <MenuButton
              border={"none"}
              as={IconButton}
              aria-label="Options"
              icon={<HamburgerIcon />}
              variant="outline"
            />
            <MenuList>
              {FollowType === "black" && (
                <MenuItem onClick={handMoveOutBlack}>解除黑名单</MenuItem>
              )}
              {FollowType !== "black" && (
                <>
                  <MenuItem onClick={handToBlack}>加入黑名单</MenuItem>
                  <MenuItem onClick={handNotLetLook}>不让他看</MenuItem>
                  <MenuItem onClick={handNotLook}>不看他</MenuItem>
                </>
              )}
            </MenuList>
          </Menu>
        </Flex>
      </Flex>
    </Box>
  );
};

export default MyFollowing;
